import FormattedList from 'I18n/components/FormattedList';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { SuccessIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BusinessObjectivesFeaturesBullet = ({
  features
}) => {
  return /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsx(View, {
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(SuccessIcon, {
          color: 'text-core-default'
        })
      }), /*#__PURE__*/_jsxs(Text, {
        as: "span",
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "merchCards.businessObjectives.removeBranding"
        }), "\xA0", /*#__PURE__*/_jsxs(FormattedList, {
          children: [features.map(feature => /*#__PURE__*/_jsx(Tooltip, {
            placement: "right",
            title: /*#__PURE__*/_jsx(SanitizedText, {
              body: feature.description,
              formattingOptions: {
                isPlainText: false,
                shouldPreserveNewlines: true,
                shouldOpenLinksInNewTab: true
              }
            }),
            children: /*#__PURE__*/_jsx(Text, {
              as: "span",
              children: feature.displayName
            })
          }, feature.shortName)), /*#__PURE__*/_jsx(Text, {
            as: "span",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "merchCards.businessObjectives.more"
            })
          })]
        })]
      })]
    })
  });
};
export default BusinessObjectivesFeaturesBullet;